import {Component, HostListener, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { LoginDto } from '../models/auth/login-dto.model';
import { AuthenticationService } from '../services/user/authentication.service';
import { MessageService } from 'primeng/api';
import {SelectBoxModel} from "../models/select-box-model";
@Component({
    selector: 'app-login',
    templateUrl: './app.login.component.html',
})
export class AppLoginComponent implements OnInit {

    loginDto: LoginDto  = new LoginDto();
    isLoading = false;
    username: string = ""
    password: string = "";
    rememberMe = true;


    constructor(private authService: AuthenticationService, private router: Router, private messageService: MessageService) {
    }

    ngOnInit(): void {

        if(localStorage.getItem('rememberMe')) {
            this.rememberMe = true;
            this.username = JSON.parse(localStorage.getItem('rememberMe')).username;
            this.password = JSON.parse(localStorage.getItem('rememberMe')).password;
        }

        this.authService.loginNew().subscribe(res => {
            if (res)  this.loginDto = res;
        },err => {
            console.log(err);
        });
    }



    @HostListener('document:keydown.enter')
    authenticate() {
        if (this.isLoading)   return null;

        this.isLoading = true;
        this.loginDto.username = this.username;
        this.loginDto.password = this.password;

        localStorage.removeItem('portalToken');

        if(this.rememberMe) {
            localStorage.setItem('rememberMe', JSON.stringify({'username': this.username, 'password': this.password}));
        }

        this.authService.login(this.loginDto).subscribe(auth => {
            let user = auth.user;
            let sessionId = auth.sessionId;
            let portalToken = auth.portalToken;

            localStorage.setItem("portalToken", portalToken);
            localStorage.setItem("sessionId", sessionId);
            localStorage.setItem('user', JSON.stringify(user));

            if(auth.selectBoxDTOS) {
                auth.selectBoxDTOS.forEach(sb  => {
                  localStorage.setItem(sb.name, JSON.stringify(sb.items));
                })
            }
            sessionStorage.setItem('firm', this.loginDto.firm.name);

            this.isLoading = false;

            this.router.navigate(['/'])
        }, e => {
            console.log(e);
            this.isLoading = false;
            this.messageService.add({severity: 'error', summary: 'Hata', detail: 'Kullanıcı adı veya şifre hatalı!' });
        })

    }
}
